import { render } from "./guidePicture.vue?vue&type=template&id=0b53251c&scoped=true"
const script = {}

import "./guidePicture.vue?vue&type=style&index=0&id=0b53251c&lang=scss&scoped=true"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b53251c"]])

export default __exports__